import { Row, Col } from "react-bootstrap";
import Image from "next/image";
import EmptyStateImage from '../assets/Illustrations/newsletter bw 1.svg'

const EmptyState = () => {
  return (
    <div className="mb-5"> 
      <Row className="justify-content-center"  >
          <Col md={12} lg={12}  className="d-flex justify-content-lg-center mt-0">
          <Image  src={EmptyStateImage} width={700} height={400} className="mt-0"/>
          </Col>
      </Row>
      <Row>
          <Col md={12} lg={12} className="d-flex justify-content-lg-center">
            <h5 className="text-center" style={{fontWight: "600"}}>Didn’t find what you were looking for?</h5>
          </Col>
                    <Col md={12} lg={12} className="d-flex justify-content-lg-center">
              <p className="text-center">Try a different search keyword to see if you can find what you’re looking for!</p>
          </Col>
      </Row>
    </div>
  );
}

export default EmptyState;
